module.exports = __webpack_public_path__ + "static/media/WhatIsCulture_6B.32f3e15b.png";